import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  alertInfo: {
    message: "",
    open: false,
    severity: "info",
  },
};

const userSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    updateAlertInfo(state, action) {
      state.alertInfo = action.payload;
    },
  },
});

export const { updateAlertInfo } = userSlice.actions;
export default userSlice.reducer;
